import React from "react";

const WidgetOpcionesConfirmarSeguirVenta = (props) => {
    const enviarMensajeComoUsuario = (texto, handler) => {
        props.setState((prevState) => ({
            ...prevState,
            messages: [
                ...prevState.messages,
                { message: texto, type: "user" },
            ],
        }));
        handler();
    };

    const opciones = [
        {
            text: "Sí",
            handler: () =>
                enviarMensajeComoUsuario("Sí", () =>
                    props.actionProvider.manejarFlujoVenta("sí")
                ),
            id: 1,
        },
        {
            text: "No, editar",
            handler: () =>
                enviarMensajeComoUsuario("No, editar", () =>
                    props.actionProvider.manejarFlujoVenta("no, editar")
                ),
            id: 2,
        },
        {
            text: "Guardar en prospectos",
            handler: () =>
                enviarMensajeComoUsuario("Guardar en prospectos", () =>
                    props.actionProvider.manejarFlujoVenta("guardar en prospectos")
                ),
            id: 3,
        },
    ];

    return (
        <div className="chat-options-container">
            {opciones.map((opcion) => (
                <button
                    className="chat-option-button px-3"
                    key={opcion.id}
                    onClick={opcion.handler}
                >
                    {opcion.text}
                </button>
            ))}
        </div>
    );
};

export default WidgetOpcionesConfirmarSeguirVenta;
